// extracted by mini-css-extract-plugin
export default {"container":"editable-data_container__siKzQ","textarea":"editable-data_textarea__kZdMj","buttons":"editable-data_buttons__EY4-f"};